
import htmlTemp from './tail-bar.html';
require('./tail-bar.scss');

angular.module('RCP').directive('tailBar', function () {
    return {
        restrict: 'E',
        replace: true,
        template: htmlTemp,
        controller: function ($scope, service, $timeout, $element) {

        }
    }
});


// WEBPACK FOOTER //
// ./src/recruit/src/directive/tail-bar/tail-bar.js